import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import ModalRoot from './ModalRoot';
import ModalRootBranched from '../ModalRoot.modals_match_theme';
export default withFeatureBranch({
    modals_match_theme: ModalRootBranched
})(ModalRoot);
